const WP_LIB =
  'https://payments.worldpay.com/resources/hpp/integrations/embedded/js/hpp-embedded-integration-library.js';

/**
 * Loads the worldpay javascript libary into the document
 */

const loadWorldpayLibrary = () =>
  new Promise((resolve, reject) => {
    if (global.WPCL) {
      // Already loaded
      resolve(global.WPCL);
      return;
    }

    const script = document.createElement('script');
    script.src = WP_LIB;
    script.onload = () => resolve(global.WPCL);
    script.onerror = reject;
    document.head.appendChild(script);
  });

export default loadWorldpayLibrary;
